// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sashe-history-page {
  padding: 1.5rem;
  max-width: 1600px;
  margin: 0 auto;
}

.sashe-history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.sashe-history-header h1 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: var(--text-primary, #e2e8f0);
  font-size: 1.6rem;
}

.user-filter {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  color: rgba(226, 232, 240, 0.7);
}

.user-filter select {
  background: transparent;
  border: none;
  color: var(--text-primary, #e2e8f0);
  font-size: 0.95rem;
  outline: none;
  cursor: pointer;
}

.user-filter select option {
  background: #1e293b;
  color: #e2e8f0;
}

.sashe-history-grid {
  display: grid;
  grid-template-columns: 360px 360px 1fr;
  gap: 1.25rem;
  align-items: start;
}

@media (max-width: 1280px) {
  .sashe-history-grid {
    grid-template-columns: 1fr 1fr;
  }
  .history-detail-panel {
    grid-column: 1 / -1;
  }
}

@media (max-width: 768px) {
  .sashe-history-grid {
    grid-template-columns: 1fr;
  }
}

.history-calendar-panel,
.history-runs-panel,
.history-detail-panel {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 1rem 1.2rem;
}

.history-calendar-panel h3,
.history-runs-panel h3,
.history-detail-panel h3 {
  margin: 0 0 0.85rem 0;
  font-size: 1.05rem;
  color: var(--text-primary, #e2e8f0);
}

/* React-calendar overrides for dark theme */
.react-calendar {
  background: transparent !important;
  border: none !important;
  width: 100% !important;
  font-family: inherit;
}

.react-calendar button {
  color: rgba(226, 232, 240, 0.85);
  background: transparent;
}

.react-calendar__navigation button {
  color: var(--text-primary, #e2e8f0);
  font-weight: 600;
  min-width: 36px;
}

.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
  background: rgba(255, 255, 255, 0.05) !important;
}

.react-calendar__month-view__weekdays__weekday abbr {
  text-decoration: none;
  color: rgba(226, 232, 240, 0.5);
  font-weight: 600;
  font-size: 0.75rem;
}

.react-calendar__tile {
  position: relative;
  padding: 12px 6px 18px !important;
  border-radius: 6px;
  font-size: 0.9rem;
}

.react-calendar__tile:enabled:hover,
.react-calendar__tile:enabled:focus {
  background: rgba(99, 102, 241, 0.15) !important;
}

.react-calendar__tile--now {
  background: rgba(245, 158, 11, 0.18) !important;
}

.react-calendar__tile--active {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.5), rgba(139, 92, 246, 0.5)) !important;
  color: white !important;
}

.react-calendar__month-view__days__day--neighboringMonth {
  color: rgba(226, 232, 240, 0.25) !important;
}

.cal-dots {
  position: absolute;
  bottom: 4px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 3px;
}

.cal-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.cal-dot.success { background: #10b981; }
.cal-dot.error { background: #ef4444; }
.cal-dot.other { background: #f59e0b; }

.legend {
  display: flex;
  gap: 0.85rem;
  flex-wrap: wrap;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  font-size: 0.8rem;
  color: rgba(226, 232, 240, 0.6);
}

.legend span {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Runs list */
.runs-list {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  max-height: 600px;
  overflow-y: auto;
}

.run-card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 0.75rem 0.9rem;
  cursor: pointer;
  transition: all 0.2s;
}

.run-card:hover {
  background: rgba(255, 255, 255, 0.07);
  border-color: rgba(99, 102, 241, 0.3);
}

.run-card.selected {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.15), rgba(139, 92, 246, 0.15));
  border-color: rgba(99, 102, 241, 0.5);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.run-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.4rem;
}

.run-time {
  font-weight: 600;
  color: var(--text-primary, #e2e8f0);
  font-size: 0.95rem;
}

.run-username {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: rgba(226, 232, 240, 0.6);
  font-size: 0.85rem;
  margin-bottom: 0.3rem;
}

.run-product {
  color: rgba(226, 232, 240, 0.85);
  font-size: 0.85rem;
  margin-bottom: 0.45rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.run-meta {
  display: flex;
  gap: 0.4rem;
}

.meta-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(255, 255, 255, 0.05);
  padding: 2px 8px;
  border-radius: 5px;
  font-size: 0.75rem;
  color: rgba(226, 232, 240, 0.6);
}

/* Status badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 5px;
  font-size: 0.75rem;
  font-weight: 600;
}

.status-badge.success {
  background: rgba(16, 185, 129, 0.15);
  color: #6ee7b7;
}

.status-badge.error {
  background: rgba(239, 68, 68, 0.15);
  color: #fca5a5;
}

.status-badge.other {
  background: rgba(245, 158, 11, 0.15);
  color: #fcd34d;
}

/* Detail panel */
.detail-summary {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  padding: 0.85rem 1rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  color: rgba(226, 232, 240, 0.85);
  font-size: 0.9rem;
}

.detail-summary strong {
  color: rgba(226, 232, 240, 0.55);
  margin-right: 6px;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.empty-state {
  text-align: center;
  padding: 3rem 1rem;
  color: rgba(226, 232, 240, 0.4);
  font-size: 0.95rem;
}

/* Media section */
.media-section {
  margin-bottom: 1rem;
}

.media-section h4 {
  font-size: 0.95rem;
  color: var(--text-primary, #e2e8f0);
  margin: 1rem 0 0.6rem;
}

.btn-show-gif {
  background: linear-gradient(135deg, rgba(168, 85, 247, 0.3), rgba(236, 72, 153, 0.3));
  border: 1px solid rgba(168, 85, 247, 0.4);
  color: #f0abfc;
  padding: 0.55rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.btn-show-gif:hover {
  background: linear-gradient(135deg, rgba(168, 85, 247, 0.45), rgba(236, 72, 153, 0.45));
  transform: translateY(-1px);
}

/* Thumbnails grid */
.thumb-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 0.6rem;
  max-height: 480px;
  overflow-y: auto;
  padding-right: 4px;
}

.thumb {
  position: relative;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  aspect-ratio: 16 / 9;
  transition: all 0.2s;
}

.thumb:hover {
  border-color: rgba(99, 102, 241, 0.5);
  transform: scale(1.03);
}

.thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.thumb-loading {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.04));
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.thumb-label {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  color: white;
  font-size: 0.7rem;
  padding: 12px 6px 4px;
  text-align: center;
}

/* Log block */
.run-log {
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 1rem;
  color: rgba(226, 232, 240, 0.8);
  font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;
  font-size: 0.78rem;
  line-height: 1.55;
  max-height: 500px;
  overflow: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}

/* Image viewer (lightbox) */
.image-viewer-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.92);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.viewer-img {
  max-width: 95%;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 6px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
}

.viewer-loading {
  color: white;
  font-size: 1.1rem;
}

.viewer-close,
.viewer-nav {
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: white;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.2s;
}

.viewer-close:hover,
.viewer-nav:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.viewer-close {
  top: 1.5rem;
  right: 1.5rem;
}

.viewer-nav.prev {
  left: 1.5rem;
}

.viewer-nav.next {
  right: 1.5rem;
}

.viewer-counter {
  position: absolute;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 0.85rem;
}
`, "",{"version":3,"sources":["webpack://./src/features/sashe/SasheHistory.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qCAAqC;EACrC,2CAA2C;EAC3C,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;;EAGE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;EAGE,qBAAqB;EACrB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA,4CAA4C;AAC5C;EACE,kCAAkC;EAClC,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gGAAgG;EAChG,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA,mBAAmB,mBAAmB,EAAE;AACxC,iBAAiB,mBAAmB,EAAE;AACtC,iBAAiB,mBAAmB,EAAE;;AAEtC;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,+CAA+C;EAC/C,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,uFAAuF;EACvF,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,qFAAqF;EACrF,yCAAyC;EACzC,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,uFAAuF;EACvF,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mHAAmH;EACnH,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,4DAA4D;EAC5D,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,uDAAuD;EACvD,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,oCAAoC;EACpC,2CAA2C;EAC3C,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".sashe-history-page {\n  padding: 1.5rem;\n  max-width: 1600px;\n  margin: 0 auto;\n}\n\n.sashe-history-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.sashe-history-header h1 {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  color: var(--text-primary, #e2e8f0);\n  font-size: 1.6rem;\n}\n\n.user-filter {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  padding: 0.5rem 0.75rem;\n  border-radius: 8px;\n  color: rgba(226, 232, 240, 0.7);\n}\n\n.user-filter select {\n  background: transparent;\n  border: none;\n  color: var(--text-primary, #e2e8f0);\n  font-size: 0.95rem;\n  outline: none;\n  cursor: pointer;\n}\n\n.user-filter select option {\n  background: #1e293b;\n  color: #e2e8f0;\n}\n\n.sashe-history-grid {\n  display: grid;\n  grid-template-columns: 360px 360px 1fr;\n  gap: 1.25rem;\n  align-items: start;\n}\n\n@media (max-width: 1280px) {\n  .sashe-history-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n  .history-detail-panel {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (max-width: 768px) {\n  .sashe-history-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.history-calendar-panel,\n.history-runs-panel,\n.history-detail-panel {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 1rem 1.2rem;\n}\n\n.history-calendar-panel h3,\n.history-runs-panel h3,\n.history-detail-panel h3 {\n  margin: 0 0 0.85rem 0;\n  font-size: 1.05rem;\n  color: var(--text-primary, #e2e8f0);\n}\n\n/* React-calendar overrides for dark theme */\n.react-calendar {\n  background: transparent !important;\n  border: none !important;\n  width: 100% !important;\n  font-family: inherit;\n}\n\n.react-calendar button {\n  color: rgba(226, 232, 240, 0.85);\n  background: transparent;\n}\n\n.react-calendar__navigation button {\n  color: var(--text-primary, #e2e8f0);\n  font-weight: 600;\n  min-width: 36px;\n}\n\n.react-calendar__navigation button:enabled:hover,\n.react-calendar__navigation button:enabled:focus {\n  background: rgba(255, 255, 255, 0.05) !important;\n}\n\n.react-calendar__month-view__weekdays__weekday abbr {\n  text-decoration: none;\n  color: rgba(226, 232, 240, 0.5);\n  font-weight: 600;\n  font-size: 0.75rem;\n}\n\n.react-calendar__tile {\n  position: relative;\n  padding: 12px 6px 18px !important;\n  border-radius: 6px;\n  font-size: 0.9rem;\n}\n\n.react-calendar__tile:enabled:hover,\n.react-calendar__tile:enabled:focus {\n  background: rgba(99, 102, 241, 0.15) !important;\n}\n\n.react-calendar__tile--now {\n  background: rgba(245, 158, 11, 0.18) !important;\n}\n\n.react-calendar__tile--active {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.5), rgba(139, 92, 246, 0.5)) !important;\n  color: white !important;\n}\n\n.react-calendar__month-view__days__day--neighboringMonth {\n  color: rgba(226, 232, 240, 0.25) !important;\n}\n\n.cal-dots {\n  position: absolute;\n  bottom: 4px;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  gap: 3px;\n}\n\n.cal-dot {\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n}\n\n.cal-dot.success { background: #10b981; }\n.cal-dot.error { background: #ef4444; }\n.cal-dot.other { background: #f59e0b; }\n\n.legend {\n  display: flex;\n  gap: 0.85rem;\n  flex-wrap: wrap;\n  margin-top: 0.75rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  font-size: 0.8rem;\n  color: rgba(226, 232, 240, 0.6);\n}\n\n.legend span {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Runs list */\n.runs-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  max-height: 600px;\n  overflow-y: auto;\n}\n\n.run-card {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  padding: 0.75rem 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.run-card:hover {\n  background: rgba(255, 255, 255, 0.07);\n  border-color: rgba(99, 102, 241, 0.3);\n}\n\n.run-card.selected {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.15), rgba(139, 92, 246, 0.15));\n  border-color: rgba(99, 102, 241, 0.5);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n.run-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.4rem;\n}\n\n.run-time {\n  font-weight: 600;\n  color: var(--text-primary, #e2e8f0);\n  font-size: 0.95rem;\n}\n\n.run-username {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  color: rgba(226, 232, 240, 0.6);\n  font-size: 0.85rem;\n  margin-bottom: 0.3rem;\n}\n\n.run-product {\n  color: rgba(226, 232, 240, 0.85);\n  font-size: 0.85rem;\n  margin-bottom: 0.45rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.run-meta {\n  display: flex;\n  gap: 0.4rem;\n}\n\n.meta-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: rgba(255, 255, 255, 0.05);\n  padding: 2px 8px;\n  border-radius: 5px;\n  font-size: 0.75rem;\n  color: rgba(226, 232, 240, 0.6);\n}\n\n/* Status badges */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 8px;\n  border-radius: 5px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.status-badge.success {\n  background: rgba(16, 185, 129, 0.15);\n  color: #6ee7b7;\n}\n\n.status-badge.error {\n  background: rgba(239, 68, 68, 0.15);\n  color: #fca5a5;\n}\n\n.status-badge.other {\n  background: rgba(245, 158, 11, 0.15);\n  color: #fcd34d;\n}\n\n/* Detail panel */\n.detail-summary {\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 8px;\n  padding: 0.85rem 1rem;\n  margin-bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  color: rgba(226, 232, 240, 0.85);\n  font-size: 0.9rem;\n}\n\n.detail-summary strong {\n  color: rgba(226, 232, 240, 0.55);\n  margin-right: 6px;\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: rgba(226, 232, 240, 0.4);\n  font-size: 0.95rem;\n}\n\n/* Media section */\n.media-section {\n  margin-bottom: 1rem;\n}\n\n.media-section h4 {\n  font-size: 0.95rem;\n  color: var(--text-primary, #e2e8f0);\n  margin: 1rem 0 0.6rem;\n}\n\n.btn-show-gif {\n  background: linear-gradient(135deg, rgba(168, 85, 247, 0.3), rgba(236, 72, 153, 0.3));\n  border: 1px solid rgba(168, 85, 247, 0.4);\n  color: #f0abfc;\n  padding: 0.55rem 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n  transition: all 0.2s;\n}\n\n.btn-show-gif:hover {\n  background: linear-gradient(135deg, rgba(168, 85, 247, 0.45), rgba(236, 72, 153, 0.45));\n  transform: translateY(-1px);\n}\n\n/* Thumbnails grid */\n.thumb-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 0.6rem;\n  max-height: 480px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.thumb {\n  position: relative;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  cursor: pointer;\n  overflow: hidden;\n  aspect-ratio: 16 / 9;\n  transition: all 0.2s;\n}\n\n.thumb:hover {\n  border-color: rgba(99, 102, 241, 0.5);\n  transform: scale(1.03);\n}\n\n.thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.thumb-loading {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.04));\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n@keyframes shimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n.thumb-label {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));\n  color: white;\n  font-size: 0.7rem;\n  padding: 12px 6px 4px;\n  text-align: center;\n}\n\n/* Log block */\n.run-log {\n  background: rgba(0, 0, 0, 0.4);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 8px;\n  padding: 1rem;\n  color: rgba(226, 232, 240, 0.8);\n  font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;\n  font-size: 0.78rem;\n  line-height: 1.55;\n  max-height: 500px;\n  overflow: auto;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n/* Image viewer (lightbox) */\n.image-viewer-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.92);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n}\n\n.viewer-img {\n  max-width: 95%;\n  max-height: 90vh;\n  object-fit: contain;\n  border-radius: 6px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);\n}\n\n.viewer-loading {\n  color: white;\n  font-size: 1.1rem;\n}\n\n.viewer-close,\n.viewer-nav {\n  position: absolute;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: white;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: all 0.2s;\n}\n\n.viewer-close:hover,\n.viewer-nav:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: scale(1.1);\n}\n\n.viewer-close {\n  top: 1.5rem;\n  right: 1.5rem;\n}\n\n.viewer-nav.prev {\n  left: 1.5rem;\n}\n\n.viewer-nav.next {\n  right: 1.5rem;\n}\n\n.viewer-counter {\n  position: absolute;\n  bottom: 1.5rem;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: white;\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 0.85rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
